export const INITIALIZE = "INITIALIZE"
export const UPDATE_CHECKED_IDS = "UPDATE_CHECKED_IDS"
export const PURCHASE = "PURCHASE"
export const READ = "READ"
export const IS_PURCHASED = "IS_PURCHASED"
export const SET_TAX = "SET_TAX"
export const UPDATE_ITEMS = "UPDATE_ITEMS"
